import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import {
  findData,
  resetFind,
  updateData,
} from '~/store/modules/cercasVirtuais/actions';

import GoogleMaps from '../Maps';

export default function Google({ open, visible, id }) {
  const dispatch = useDispatch();
  const {
    idcercavirtual,
    descricaocercavirtual,
    zoommapacercavirtual,
    itens,
  } = useSelector((state) => state.cercasvirtuais.find);

  useEffect(() => {
    if (!open) {
      dispatch(resetFind());
      return;
    }

    if (id) {
      dispatch(findData(id));
    }
  }, [dispatch, id, open]);

  return (
    <GoogleMaps
      edit
      visible={visible}
      callback={(values) => dispatch(updateData({ ...values, idcercavirtual }))}
      initials={
        idcercavirtual
          ? {
              zoom: zoommapacercavirtual,
              items: itens,
              form: { descricaocercavirtual },
            }
          : {}
      }
    />
  );
}

Google.propTypes = {
  open: PropTypes.bool.isRequired,
  visible: PropTypes.bool,
  id: PropTypes.number,
};

Google.defaultProps = {
  visible: false,
  id: null,
};
